module.exports = __webpack_public_path__ + "img/zhi.1b73edc3.png";